import React, { useState } from 'react';
import Header from '../../Components/ContributePageComponent.js/Contribute/Header';
import AddProject from '../../Components/ApiRepoContributor/Form';
import ProjectTable from '../../Components/ApiRepoContributor/ProjectTable';
import { useNavigate } from 'react-router-dom';

const APIRepoContributePage = ({ active }) => {
    const [addProject, setAddProject] = useState(false);
    const navigate = useNavigate();
    const closeContributor = () => {
        navigate("/dashboard/api_repo")
    }
    return (
        <div>
            <div>
                <Header active={active} />
            </div>
            <div className='-mt-10 h-[80vh] bg-white w-[90%] m-auto shadow-custom relative'>
                <div className='pl-2'>
                    <button className='p-4 pb-2 text-sm font-semibold border-b-2'>
                        My Projects
                    </button>
                </div>
                <div className='flex justify-end p-2 items-center'>
                    <button
                        className='text-[#1976D2] flex border-[#1976D2] border px-4 py-1 text-sm items-center rounded-md'
                        onClick={() => setAddProject(true)}
                    >
                        Add Project
                    </button>
                </div>
                <div>
                    <ProjectTable />

                </div>
                <div className='absolute bottom-2 right-2'>
                    <button
                        className='text-white bg-[#1976D2] flex border-[#1976D2] border px-4 py-1 text-sm items-center rounded-md'
                        onClick={closeContributor}
                    >
                        Close
                    </button>
                </div>
            </div>

            {/* Modal */}
            {addProject && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                    <AddProject onClose={() => setAddProject(false)} />
                </div>
            )}

        </div>
    );
};

export default APIRepoContributePage;
